import React ,{useState }from 'react'
import styled from "styled-components";
import firebase from "firebase/app";
import { db } from "../firebase";
import { Button } from "@material-ui/core";

function ChatInput({channelName, channelId}) {
    const [input, setInput] = useState('')
    const sendMessage = async (e) =>{
     e.preventDefault();
     console.log(`this my id ${input}`)
     if (channelId) {
        await db.collection("rooms").doc(channelId).collection("messages").add({
            message: input,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            user: "joshua",
            userImage: "https://theonetechnologies.com/blog/Content/images/banners/react_js.png"
        });
           setInput("")
    
        
     }
    
    };
    return (
        <ChatInputContainer>
            <form  action="" onSubmit = { sendMessage}>
                <input value={input} onChange={(e) => setInput(e.target.value)} placeholder={`Message #${channelName}`}/>
                
            </form>
           

        </ChatInputContainer>
    )
}

export default ChatInput
const ChatInputContainer = styled.div`
  border-radius: 40px;

  >form {  
      position: relative;
      display: flex;
      justify-content: center;
  }
   >form > input {
       position: fixed;
       bottom: 30px;
       width:60%;
       border-radius: 3px;
       padding: 20px;
       outline: none;

   }
   >form > Button{
       display: none !important
   }
`;